module.exports = __webpack_public_path__ + "static/01-678cae389e7ebd3f0df833d803cc90fc.jpg";